module.exports = __webpack_public_path__ + "static/media/aeps_1.310cfb27.svg";